import React from "react";

import { HOW_TO } from "../../utils/howTo";
import { useIsMobile } from "../../../../../../device/selectors";

const CumParticipTab = () => {
  const isMobile = useIsMobile();

  return (
    <>
      <div className={"uppercase text-dark-1 font-bold text-lg leading-6 text-center mb-6 lg:text-xl lg:leading-6.5"}>
        How it works?
      </div>
      {HOW_TO.map(({ ExtraComponent, ...item }, i) => (
        <div key={i} className={"flex gap-4 mb-8"}>
          <div className={"flex-center size-16 min-w-16"}>
            <div className={"size-11 lg:size-12 relative"}>
              <div
                className={
                  "rounded-full bg-primary text-white text-xs leading-4 font-semibold size-[18px] absolute top-0 left-0 flex-center -translate-x-1/2 -translate-y-1/2"
                }>
                {i + 1}
              </div>
              <img className="size-full" src={item?.image} />
              {i < 2 && (
                <div
                  className={`w-0.5 absolute top-full left-1/2 -translate-x-1/2 my-4 ${i === 0 ? "h-[78px]" : "h-[48px]"}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="79"
                    viewBox="0 0 8 79"
                    fill="none"
                    className={"h-full w-2"}>
                    <path
                      d="M3.32845 78.3536C3.52372 78.5488 3.8403 78.5488 4.03556 78.3536L7.21754 75.1716C7.4128 74.9763 7.4128 74.6597 7.21754 74.4645C7.02228 74.2692 6.7057 74.2692 6.51043 74.4645L3.68201 77.2929L0.85358 74.4645C0.658318 74.2692 0.341735 74.2692 0.146473 74.4645C-0.0487891 74.6597 -0.0487891 74.9763 0.146473 75.1716L3.32845 78.3536ZM3.68201 78L4.18201 78L4.18201 2.18557e-08L3.68201 0L3.18201 -2.18557e-08L3.18201 78L3.68201 78Z"
                      fill="black"
                      fill-opacity="0.08"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
          <div className={"flex flex-col text-left gap-2"}>
            <div className="text-base lg:text-lg font-semibold leading-5.5 lg:leading-6 bg-gradient-botb bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">
              {item.header}
            </div>
            <div className={"text-secondary text-sm lg:text-base leading-5 lg:leading-5.5 font-normal"}>
              {item.description}
            </div>
            {ExtraComponent ? <ExtraComponent /> : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default CumParticipTab;
